export class Colorutil{
    public static generateColorPalette(col1:{r:number,g:number,b:number},col2:{r:number,g:number,b:number}, nColors: number){
        let palette:any = []
        let nCols = nColors -1;
        for (let i = 0; i<nColors;i++){
            let r = col1.r + (col2.r-col1.r) * i / nCols
            let g = col1.g + (col2.g-col1.g) * i / nCols
            let b = col1.b + (col2.b-col1.b) * i / nCols
            let srgb = "rgb("+r.toFixed(0)+","+g.toFixed(0)+","+b.toFixed(0)+")";
            palette.push(srgb)
        }
        return palette
    }
}